import React, {Component} from "react";
import {
  Button,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Table
} from "reactstrap";
import AddButton from "../../../common/AddButton/AddButton";
import ActivationButton from "../../../common/ActivationButton/ActivationButton";
import Checkbox from "../../../common/Checkbox/Checkbox";
import {sortBy} from "../../../utils";
import history from "../../../history";
import Dropdown from "../../../common/Dropdown/Dropdown";
import ProductService from "../../../services/product-service";
import toastr from "toastr";
import ToastOptions from "../../../common/toast/toastr-config.js";
import Loading from "../../../common/Loading/Loading";
import "./AccountProducts.css";
import AccountService from "../../../services/account-service";
import Permissions from "../../../authentication/Permissions";
import AuthorizationService from "../../../services/authorization-service";

class AccountProducts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      products: [],
      isAddAccountProductModalVisible: false,
      isAddAccountProductServicesModalVisible: false,
      isDialogLoading: false,
      newProductName: "Select Product",
      newUnitId: "",
      newE0Number: "",
      newProductServices: [],
      newProductSelectedServices: [],
      isUserType: false,
      description: "",
      invalidFields: {
        name: {
          invalid: false,
          message: ""
        },
        unitId: {
          invalid: false,
          message: ""
        },
        e0Number: {
          invalid: false,
          message: ""
        },
        newProductSelectedServices: {
          invalid: false,
          message: ""
        }
      },
      appStructure: ""
    }
  }

  fetchProducts = async () => {
    try {
      this.setState({ isDialogLoading: true });
      const response = await ProductService.getAllProducts();
      const products = response.data.products;
      const added = this.props.subscriptions
        ? this.props.subscriptions.map(p => p.productName)
        : [];
      const filtered = products.filter(p => (!added.includes(p.name) && p.type === "USER" && p.isActive) || (p.type === "API" && p.isActive));
      this.setState({ products: filtered, isDialogLoading: false });
    } catch (error) {
      toastr.options = ToastOptions;
      toastr.error(error.message);
    }
  }

  fetchProductServices = async (productName) => {
    try {
      const response = await ProductService.getProductsByCriteria({ q: productName, page: 0, itemsPerPage: 1 });
      const services = response.products[0].services;
      const description = response.products[0].description;
      this.setState({ 
        newProductServices: services,
        newProductSelectedServices: services.map(s => s.serviceName),
        description });
    } catch (error) {
      toastr.options = ToastOptions;
      toastr.error(error.message);
    }
  }

  handleAddAccountProductDialogToggle = async () => {
    if (!this.state.isAddAccountProductModalVisible) {
      this.setState({ isDialogLoading: true });
      await this.fetchProducts();
      this.setState({ isDialogLoading: false });
    } 

    this.setState({
      isAddAccountProductModalVisible: !this.state.isAddAccountProductModalVisible,
    });
  }

  handleAddServicesDialogToggle = async () => {
    if (!this.state.isAddAccountProductServicesModalVisible) {
      this.setState({ isDialogLoading: true });
      await this.fetchProductServices(this.state.newProductName);
      this.setState({ isDialogLoading: false });
    } 

    this.setState({
      isAddAccountProductServicesModalVisible: !this.state.isAddAccountProductServicesModalVisible,
    });
  }

  resetState = () => {
    this.setState({
      isAddAccountProductModalVisible: false,
      isAddAccountProductServicesModalVisible: false,
      isDialogLoading: false,
      newProductName: "Select Product",
      newUnitId: "",
      newE0Number: "",
      newProductServices: [],
      newProductSelectedServices: [],
      description: "",
      invalidFields: {
        name: {
          invalid: false,
          message: ""
        },
        unitId: {
          invalid: false,
          message: ""
        },
        e0Number: {
          invalid: false,
          message: ""
        },
        newProductSelectedServices: {
          invalid: false,
          message: ""
        }
      },
      isUserType: false,
      appStructure: ""
    })
  }

  convertSubState = async (sub) => {
    try {
      this.setState({isDialogLoading: true});
      let updatedAccount = {...this.props.account};
      sub.isActive = !sub.isActive;
      sub.isSynchronize = false;
      sub.isApiGeeSynced = false;
      updatedAccount.subscriptions = updatedAccount.subscriptions.map(s => s.uuid === sub.uuid ? sub : s);
      this.props.updateAccount(updatedAccount);
      this.setState({isDialogLoading: false});
    } catch (error) {
      this.setState({isDialogLoading: false});
      toastr.options = ToastOptions;
      toastr.error(error.message);
    }
  }



  selectProduct = (product) => {
    const foundProducts = this.state.products.filter(p => p.name === product);
    if (foundProducts.length > 0 && foundProducts[0].type !== "API") {
      this.setState({
        isUserType: true,
        appStructure: foundProducts[0].appStructure
      });
    } else {
      this.setState({isUserType: false, appStructure: ""});
    }

    this.setState({ newProductName: product });
    if(this.state.invalidFields.name.invalid){
      this.setState({ 
        invalidFields: {
          ...this.state.invalidFields,
          name: {
            invalid: false,
            message: ""
          }
        }
      });
    }
  }

  addAccountProductNext = () => {
    if(this.state.newProductName !== "Select Product" &&
      !this.state.invalidFields.unitId.invalid &&
      !this.state.invalidFields.e0Number.invalid){
      this.handleAddAccountProductDialogToggle();
      this.handleAddServicesDialogToggle();
    } else {
      this.setState({ 
        invalidFields: {
          ...this.state.invalidFields,
          name: {
            invalid: true,
            message: "Product is required."
          }
        }
      });
    }
  }

  validateField = (e, fieldName) => {
    let newValue = e.target.value;
    let isFieldInvalid = this.state.invalidFields[fieldName].invalid;
    let message = this.state.invalidFields[fieldName].message;
    if (!/^([A-Za-z0-9]{0,64})$/.test(newValue)) {
      isFieldInvalid = true;
      message = "Must not contain space or special symbols.";
    } else {
      isFieldInvalid = false;
      message = "";
    }

    this.setState({
      invalidFields: {
        ...this.state.invalidFields,
        [fieldName]: {
          invalid: isFieldInvalid,
          message: message
        }
      },
      [`new${fieldName.charAt(0).toUpperCase() + fieldName.slice(1)}`]: e.target.value
    });
  }

  redirectToAccountProductDetailsPage = (subscription) => {
    const subscriptionDetails = {
      account: this.props.account,
      sub: subscription
    };
    history.push(
        `/accounts/${this.props.account.id}/${AccountService.subscriptionName(subscription)}`,
        subscriptionDetails,
    );
  }

  buildProductDescription = (sub) => {
    if (sub.connectedProducts && sub.connectedProducts.length > 0) {
      return sub.connectedProducts.map(s => s.productName);
    }
    return "Product";
  }

  populateTable = () => {
    if (this.props.account.subscriptions) {
      return this.props.account.subscriptions.map((subscription, i) => {
        return (
            <tr key={i} className={!subscription.isActive ? "inactive-row" : "active-row"}>
              <td className="width-40"
                  onClick={() => this.redirectToAccountProductDetailsPage(subscription)}
              >
                {this.buildProductDescription(subscription)}
              </td>
              <td className="width-10"
                  onClick={() => this.redirectToAccountProductDetailsPage(subscription)}
              >
                {subscription.unitId ? subscription.unitId : "No Unit ID"}
              </td>
              <td className="width-15"
                  onClick={() => this.redirectToAccountProductDetailsPage(subscription)}
              >
                {subscription.e0Number ? subscription.e0Number : "No E0 Number"}
              </td>
              <td className="width-10"
                  onClick={() => this.redirectToAccountProductDetailsPage(subscription)}
              >
                {subscription.isActive ? "Active" : "Inactive"}
              </td>
              {AuthorizationService.hasPermission(Permissions.subscription.changeStatus) && this.props.account.isActive && (subscription.isSynchronize === undefined || subscription.isSynchronize === false) &&
              <td className="width-25">
                <ActivationButton
                    item={subscription}
                    toggleFunction={this.convertSubState}
                    isActive={subscription.isActive}
                    description={` UnitId: ${subscription.unitId}, Ezero: ${subscription.e0Number}`}
                    header="subscription"
                />
              </td>
              }
              {subscription.isSynchronize === true &&
              <td className="width-25">Synced with OM</td>
              }
            </tr>
        );
      });
    }
  }

  findSub = (insub, params) => {
    return insub.unitId === params.unitId && insub.e0Number === params.e0Number && insub.connectedProducts && insub.connectedProducts.length === 1
        && insub.connectedProducts[0].productId === params.connectedProducts[0].productId;
  }



  editAccount = async () => {
    if (!this.state.isUserType && this.state.newProductSelectedServices.length > 0) {
      const product = this.state.products.find(p => p.name === this.state.newProductName);
      const services = this.state.newProductSelectedServices.map(s => {
        return {
          serviceName: s
        }
      });
      const connectedProducts = [{
        productId: product.uuid,
        productName: product.name,
        type: product.type,
        services: services
      }]
      const sub = {
        unitId: this.state.newUnitId,
        e0Number: this.state.newE0Number,
        connectedProducts: connectedProducts
      };
      //Validate the unit and e0 don't already exist in the subs.
      if (this.props.account.subscriptions !== undefined) {
        let existing = this.props.account.subscriptions.find(insub => this.findSub(insub, sub));
        if (existing) {
          this.setState({
            invalidFields: {
              ...this.state.invalidFields,
              newProductSelectedServices: {
                invalid: true,
                message: "You cannot add a product with the same unit id, e0number and product where it already exists for this account."
              }
            }
          })
          return;
        }
      }

      try {
        this.setState({isDialogLoading: true});

        const response = await this.props.saveSubscription(this.props.account.id, sub);

        this.setState({
          sub: response.data,
          isDialogLoading: false,
          isAddAccountProductServicesModalVisible: false
        });
        this.redirectToAccountProductDetailsPage(response.data);
      } catch (error) {
        this.setState({isDialogLoading: false});
        this.handleErrors(error);
      }
    } else if(!this.state.isUserType && this.state.newProductSelectedServices.length === 0 && this.state.newProductServices.length > 0) {
      this.setState({
        invalidFields: {
          ...this.state.invalidFields,
          newProductSelectedServices: {
            invalid: true,
            message: "At least one service must be added to the account."
          }
        }
      })
    }
  }

  handleErrors = error => {
    let errorData = error.response.data;
    let statusCode = errorData.statusCode;
    let name = errorData.name;

    if (name === "Validation Error") {
        let newState = this.state.invalidFields;
        if (statusCode === 400) {
            let body = errorData.body;
            body.forEach(fieldError => {
                let field = fieldError.field;
                let message = fieldError.message;

                if (field === "name") {
                  newState.name.invalid = true;
                  newState.name.message = message;
                }

                if (field === "unitId") {
                  newState.name.unitId = true;
                  newState.name.message = message;
                }

                if (field === "e0Number") {
                  newState.name.e0Number = true;
                  newState.name.message = message;
                }
            });
        }
        this.setState({ invalidFields: newState });
        toastr.options = ToastOptions;
        toastr.error(`${errorData.message}.`);
    } else if(name === "StatusCodeError"){
      toastr.options = ToastOptions;
      toastr.error(`${errorData.error.message}.`);
    } else {
        toastr.options = ToastOptions;
        toastr.error(error.message);
    }
  }

  renderServices = () => {
    return this.state.newProductServices.map(s => {
      return <Checkbox 
        key={s.serviceName}
        id={s.serviceName}
        label={s.displayName}
        isChecked={this.state.newProductSelectedServices.filter(item => item === s.serviceName).length > 0}
        handleChange={() => this.handleSelectService(s.serviceName)}
      />
    })
  }

  handleSelectService = (service) => {
    let filteredServices = this.state.newProductSelectedServices.filter(s => s === service);

    if(filteredServices.length === 0){
      const services = this.state.newProductSelectedServices;
      services.push(service);
      this.setState({ newProductSelectedServices: services });
    } else {
      const services = this.state.newProductSelectedServices.filter(s => s !== service);
      this.setState({ newProductSelectedServices: services });
    }

    if (this.state.newProductSelectedServices.length > 0){
      this.setState({
        invalidFields: {
          ...this.state.invalidFields,
          newProductSelectedServices: {
            invalid: false,
            message: ""
          }
        }
      })
    }
  }

  render() {
    return (
        <div className="account-products-wrapper">
          {AuthorizationService.hasPermission(Permissions.subscription.add) && this.props.account.isActive &&
          <AddButton
              name="Add product"
              handleCreateDialogToggle={this.handleAddAccountProductDialogToggle}
              className="btn-add-product"
          />
          }
          {/* Add product first dialog*/}
        <Modal isOpen={this.state.isAddAccountProductModalVisible} size="lg">
        <ModalHeader toggle={() => {
          this.handleAddAccountProductDialogToggle();
          this.resetState();
        }}>
          Add Product
        </ModalHeader>
          {!this.state.isDialogLoading &&
            <ModalBody>
              <FormGroup className="custom_form">
                <span className="product-label">Product</span>
                <Dropdown
                  options={sortBy(this.state.products, "name").map(s => s.name)}
                  changeSelectedOption={this.selectProduct}
                  defaultValue="Select Product"
                  selectedValue={this.state.newProductName}
                />
                {this.state.invalidFields.name.invalid && (
                  <span className="product-error">
                    {this.state.invalidFields.name.message}
                  </span>
                )}
              </FormGroup>

              <FormGroup className="custom_form">
                {this.state.newUnitId !== "" && (
                  <Label
                    for="unitId"
                    className={
                      this.state.invalidFields.unitId.invalid ? "invalid" : ""
                    }
                  >
                    Unit ID
                  </Label>
                )}
                <Input
                  name="unitId"
                  id="unitId"
                  placeholder="Unit ID"
                  value={this.state.newUnitId}
                  onChange={e => this.validateField(e, "unitId")}
                  invalid={this.state.invalidFields.unitId.invalid}
                  maxLength="64"
                  autoComplete="off"
                />
                <FormFeedback className="long-err-with-count">
                  {this.state.invalidFields.unitId.invalid
                    ? this.state.invalidFields.unitId.message !== "max_length"
                      ? this.state.invalidFields.unitId.message
                      : ""
                    : "Required field"}
                </FormFeedback>
                <span
                  className={
                    this.state.invalidFields.unitId.invalid
                      ? "char-feedback-invalid"
                      : "char-feedback"
                  }
                >{`${
                  this.state.newUnitId !== ""
                    ? this.state.newUnitId.length
                    : 0
                }/64`}</span>
              </FormGroup>

              <FormGroup className="custom_form">
                {this.state.newE0Number !== "" && (
                  <Label
                    for="e0Number"
                    className={
                      this.state.invalidFields.e0Number.invalid ? "invalid" : ""
                    }
                  >
                    E0 Number
                  </Label>
                )}
                <Input
                  name="e0Number"
                  id="e0Number"
                  placeholder="E0 Number"
                  value={this.state.newE0Number}
                  onChange={e => this.validateField(e, "e0Number")}
                  invalid={this.state.invalidFields.e0Number.invalid}
                  maxLength="64"
                  autoComplete="off"
                />
                <FormFeedback className="long-err-with-count">
                  {this.state.invalidFields.e0Number.invalid
                    ? this.state.invalidFields.e0Number.message !== "max_length"
                      ? this.state.invalidFields.e0Number.message
                      : ""
                    : "Required field"}
                </FormFeedback>
                <span
                  className={
                    this.state.invalidFields.e0Number.invalid
                      ? "char-feedback-invalid"
                      : "char-feedback"
                  }
                >{`${
                  this.state.newE0Number !== ""
                    ? this.state.newE0Number.length
                    : 0
                }/64`}</span>
              </FormGroup>
            </ModalBody>
          }
          {this.state.isDialogLoading &&
            <ModalBody className="loading-body">
              <Loading />
            </ModalBody>
          }
          
          <ModalFooter>
            <Button
              color="btn btn-link"
              onClick={() => {
                this.resetState();
                this.handleAddAccountProductDialogToggle();
              }}
            >
              Cancel
            </Button>

            {!this.state.isUserType &&
              <Button
                type="button"
                className="btn btn-success submit-user-button"
                onClick={() => {
                  this.addAccountProductNext();
                }}
                disabled={this.state.isDialogLoading}
              >
                Next
              </Button>
            }

            {this.state.isUserType &&
              <Button
                type="button"
                className="btn btn-success submit-user-button"
                onClick={() => {
                  this.editAccount();
                }}
                disabled={this.state.isDialogLoading}
              >
                Save
              </Button>
            }
          </ModalFooter>
        </Modal>

        {/* Add product second dialog*/}
        <Modal isOpen={this.state.isAddAccountProductServicesModalVisible} size="lg">
          {!this.state.isDialogLoading
            ? <ModalHeader toggle={() => {
                this.handleAddServicesDialogToggle();
                this.resetState();
                }}>
                Add Service
              </ModalHeader>
            : <ModalHeader>Add Service</ModalHeader>
          }
           
          {!this.state.isDialogLoading &&
            <ModalBody>
              <div className="checkbox-container">
                {this.renderServices()}
              </div>
              {this.state.newProductServices.length === 0 && (
                <span>
                  No API Services available for that API Product.
                </span>
              )}
              {this.state.invalidFields.newProductSelectedServices.invalid && (
                <span className="product-error">
                  {this.state.invalidFields.newProductSelectedServices.message}
                </span>
              )}
            </ModalBody>
          }
          {this.state.isDialogLoading &&
            <ModalBody className="loading-body">
              <Loading />
            </ModalBody>
          }
          <ModalFooter>
            <Button
              color="btn btn-link"
              disabled={this.state.isDialogLoading}
              onClick={() => {
                this.handleAddServicesDialogToggle();
                this.handleAddAccountProductDialogToggle();
                this.setState({ 
                  invalidFields: {
                    ...this.state.invalidFields,
                    newProductSelectedServices: {
                      invalid: false,
                      message: ""
                    }
                  }
                })
              }}
            >
              Back
            </Button>
            <button
              type="button"
              className="btn btn-success submit-user-button"
              onClick={() => {
                this.editAccount();
              }}
              disabled={this.state.isDialogLoading}
            >
              Save
            </button>
          </ModalFooter>
        </Modal>

        <div className="products-table">
            <Table hover className="table">
              <thead>
              <tr>
                <th className="width-40">Name</th>
                <th className="width-10">Unit Id</th>
                <th className="width-15">E0 Number</th>
                <th className="width-10">Status</th>
                <th className="width-25">Action State</th>
              </tr>
              </thead>
              <tbody>
              {this.populateTable()}
            </tbody>
            </Table>
        </div>
      </div>
    );
  }
}

export default AccountProducts;



// WEBPACK FOOTER //
// ./src/accounts/account-details/components/AccountProducts.js